
/* -------------------------------------

	Payment

------------------------------------- */

$(document).ready(function() {


	/* dynamic surcharge */
	$('body.payment input[name="amount"]').keyup(function() {

		var amount = $(this).val();

		if(amount > 150) {

			$('label#debit span#sur').text('1%');

			return false;

		}

		$('label#debit span#sur').text('£1.50');

	});


	/* numeric only amount */
	$('body.payment input[name="amount"]').keypress(function(e) {

		return (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57) && e.which != 46) ? false : true;

	});


});
